import I, { ImmutableObject } from 'seamless-immutable';
import { TierPlansStoreEnum } from './types';

export function tokensStoreAdapter(): ImmutableObject<Record<string, any>> {
  return I({
    [TierPlansStoreEnum.TIER_PLANS]: []
  });
}
